var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Checkbox',{attrs:{"checked":_vm.item.response},on:{"input":_vm.handleInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }